export default __webpack_public_path__ + "static/media/dev_workshops.9b52ccfa.png";